import { createRoot } from 'react-dom/client';
import '@fontsource/fredoka/500.css';
import '@fontsource/fredoka/600.css';
import '@fontsource/fredoka/700.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';
import 'leaflet/dist/leaflet.css';
import './proto/proto.css';
import './proto/proto2.css';
import './proto/theme.css';
import './proto/app.css';
import { ProtoApp } from './ProtoApp';

createRoot(document.getElementById('root')!).render(<ProtoApp />);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => { /* offline shell is optional */ }); });
}
